import { query } from '../../apollo/client';

export async function calculateCopyrightAdvantage(timeAllowedCreativeWork, annualGrossIncome) {
  const { default: getUlawCopyrightCalculationsQuery } = await import(
    '../../graphql/ulaw/getUlawCopyrightCalculations'
  );

  const response = await query(getUlawCopyrightCalculationsQuery, { copyrightData: { timeAllowedCreativeWork, annualGrossIncome } });
  return response.data.getUlawCopyrightCalculations;
}
